import * as ActionTypes from "./Constants";

export const selectProject = project => dispatch => {
	dispatch({
		type: ActionTypes.SELECT_PROJECT,
		value: project._id,
	});
};
